export default __webpack_public_path__ + "locales/ko-KR/DeleteThirdPartyDialog.json?hash=5c3a58abe2e5a257ca2da582c720e29d";